
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zqhaxanmpdfwlzsdltzz.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpxaGF4YW5tcGRmd2x6c2RsdHp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1NDYxNTIsImV4cCI6MjA4MTEyMjE1Mn0.UxECkQuuWvQLLmxHFog-WPwkKjFcSiDYqWjgbQJtweY';

export const supabase = createClient(supabaseUrl, supabaseKey);
